import useResizeObserver from "@react-hook/resize-observer";
import { useRef, useState } from "react";

import { FileImageInProgress } from "@/components/file-image-in-progress/FileImageInProgress";
import { TileObjectTypeIndicator } from "@/components/ui-v2/Tiles/common/TileObjectTypeIndicator";
import {
  TileBase,
  TileBaseProps,
} from "@/components/ui-v2/Tiles/TileBase/TileBase";
import { InferenceParameters, ObjectType } from "@/types";

import type { GenerationTileAction } from "../GenerationTile/types";

export interface GenerationInProgressTileProps extends TileBaseProps {
  objectType: ObjectType;
  inferenceParameters: InferenceParameters;
  etaAt: string | Date;
  startedAt: string | Date;
  url: string;
  onAction?: (e: React.MouseEvent, action: GenerationTileAction) => void;
}

export const GenerationInProgressTile = (
  props: GenerationInProgressTileProps,
) => {
  const {
    objectType,
    inferenceParameters,
    etaAt,
    startedAt,
    url,
    isSelected = false,
    isSelectable = false,
    onAction,
    ...rest
  } = props;
  const [cardSize, setCardSize] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  const handleAction =
    (action: GenerationTileAction) => (e: React.MouseEvent) => {
      onAction?.(e, action);
    };

  useResizeObserver(containerRef, (entry) => {
    setCardSize(entry.target?.clientWidth);
  });

  return (
    <TileBase
      data-testid="object-loading"
      ref={containerRef}
      onClick={isSelectable ? handleAction("SELECT") : undefined}
      isSelected={isSelected}
      isSelectable={isSelectable}
      slots={{
        topLeftEl: TileObjectTypeIndicator,
      }}
      slotProps={{
        topLeftEl: {
          objectType,
        },
      }}
      {...rest}
    >
      <FileImageInProgress
        cardSize={cardSize}
        objectType={objectType}
        inferenceParameters={inferenceParameters}
        etaAt={new Date(etaAt)}
        startedAt={new Date(startedAt)}
        url={url}
      />
    </TileBase>
  );
};
